import React, { useEffect, useRef, useState } from 'react';
import Styles from './NewLCInput.module.scss';
import { fetchAddress } from './CoverageCheckUtils';
import { viewport } from '../../utils/utils';
import RichText from '../richtext';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
const NewLCInput = ({ content, setLcData, lcData, advData, setAdvData }: any) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [suggestionList, setSuggestionList] = useState([]);
  const [add, setAdd] = useState(false);
  const [addSkeleton, setAddSkeleton] = useState(false);
  const [focused, setFocused] = useState(false);
  const [addressNotFound, setAddressNotFound] = useState(false);
  const [addErr, setAddErr] = useState(false);
  const controllerRef = useRef<AbortController | null>(null);

  // On selection of an address
  const onSelection = (data: any, e: any): void => {
    setLcData({
      ...lcData,
      addressList: data,
      selectedAddress: e?.currentTarget && e?.currentTarget?.innerText,
      buttonClick: false
    });
    setShowSuggestion(!showSuggestion);
  };
  const HandleChange = (e: any) => {
    setAddressNotFound(false);
    const inputValue = e?.target?.value;
    setLcData({ ...lcData, selectedAddress: inputValue });
    let notValidAddress: boolean = false;
    notValidAddress = new RegExp(`[${content?.regexp}]`).test(inputValue);
    notValidAddress && setLcData({ ...lcData, setErrMsg: content?.approriateErrMsg });

    if (!notValidAddress && inputValue?.length >= 3) {
      //triggering address api
      setAdd(true);
      setAddErr(false);
      //controllerRef.current && controllerRef.current.abort();
      setAddSkeleton(true);
      fetchAddress(inputValue, controllerRef, setAddErr, isMobile ? 5 : 10).then((res: any) => {
        if (
          res &&
          res?.abortError &&
          inputRef?.current?.value?.length !== undefined &&
          inputRef?.current?.value?.length > 2
        ) {
          setAddSkeleton(true);
        } else if (res && res?.error) {
          setAddErr(true);
          setSuggestionList([]);
          setAddSkeleton(false);
        } else if (res?.length <= 0) {
          setSuggestionList([]);
          setAddressNotFound(true);
          setAddSkeleton(false);
        } else {
          setSuggestionList(res);
          setShowSuggestion(true);
          setAddSkeleton(false);
        }
      });
    } else {
      controllerRef?.current?.abort();
      setSuggestionList([]);
      setShowSuggestion(false);
      setAddSkeleton(false);
    }
  };
  // on close button click
  const handleClick = () => {
    controllerRef?.current?.abort();

    setAddressNotFound(false);
    setLcData({ ...lcData, addressList: [], selectedAddress: '' });
    setAddSkeleton(false);
  };
  useEffect(() => {
    lcData?.errMsg;
  }, [lcData?.errMsg]);

  const handleFocus = () => {
    setFocused(true);
    isMobile && setAdvData({ ...advData, openOverlay: true });
    inputRef?.current?.focus();
  };
  const viewPort = viewport();
  const isMobile = viewPort === 'mobile' ? true : false;

  useEffect(() => {
    if (advData?.openOverlay && !lcData?.buttonClick) {
      setFocused(true);
      inputRef?.current?.focus();
    } else {
      setFocused(false);
    }
  }, [advData?.openOverlay]);

  const HandleRetry = () => {
    // call HandleChange function
    HandleChange({ target: { value: lcData?.selectedAddress } });
  };

  return (
    <>
      <div className='form-floating'>
        <input
          type='text'
          onFocus={handleFocus}
          onBlur={() => setFocused(false)}
          placeholder={content?.placeholderText}
          onChange={HandleChange}
          value={lcData?.selectedAddress}
          autoComplete='off'
          aria-autocomplete='none'
          className={`${Styles.inputField} ${
            lcData?.errMsg === content?.requiredErrText && lcData?.selectedAddress == ''
              ? Styles['borderRed']
              : ''
          } form-control`}
          spellCheck='false'
          minLength={0}
          maxLength={255}
          ref={inputRef}
          // autoFocus
        />
        <label htmlFor='address' className={`input-label ${Styles['placeholderTxt']}`}>
          {content?.placeholderText}
        </label>{' '}
        {!lcData?.FetchingLineCheck &&
          lcData?.selectedAddress?.length != 0 &&
          content?.closeIcon?.filename && (
            <div className={Styles['cross-icon']} onClick={() => handleClick()}>
              <img src={content?.closeIcon?.filename} height={14} width={14} alt='cross-icon' />
            </div>
          )}
        {addSkeleton ? (
          <div className={Styles['adverr-container']}>
            <div className={Styles['advsugg']}>
              <SkeletonLoader count={1} stylename={Styles.skeleton} />
            </div>
          </div>
        ) : focused && lcData?.selectedAddress == '' && content?.suggesstionText ? (
          <div className={Styles['suggestioncontainer']}>
            <div className={Styles['suggestionTxt']}>{content?.suggesstionText}</div>
          </div>
        ) : lcData?.selectedAddress.length > 2 && addErr ? (
          <div className={Styles['adverr-container']}>
            <div className={Styles['advsugg']}>
              <RichText content={content?.serverTimeoutDesc} />
            </div>
            <hr />
            <p className={Styles['adverr']} onClick={HandleRetry}>
              <img src={content?.retryIcon?.filename} height={16} width={16} alt='edit' />
              {content?.retryButton}
            </p>
          </div>
        ) : null}
        {!addSkeleton &&
          suggestionList?.length > 0 &&
          showSuggestion &&
          lcData?.selectedAddress.length > 2 && (
            <ul className={Styles['addresscontainer']}>
              {suggestionList.map((suggestion: any, index: number) => {
                return (
                  <React.Fragment key={index}>
                    {lcData?.selectedAddress.length > 2 && (
                      <li
                        className={Styles[`suggestionactive`]}
                        key={index}
                        onClick={(e) => onSelection(suggestion, e)}
                      >
                        {suggestion && suggestion.concatedAddress}
                      </li>
                    )}
                  </React.Fragment>
                );
              })}
            </ul>
          )}
        {addressNotFound && content?.advSearchTitle && (
          <div className={Styles['adverr-container']}>
            <p className={Styles['advsugg']}>{content?.advSuggesstionTitle}</p>
            <hr />
            <p
              className={Styles['adverr']}
              onClick={() => {
                setAdvData({ ...advData, advOpen: true });
              }}
            >
              {content?.advSearchTitle}
              <img src={content?.editIcon?.filename} height={16} width={16} alt='edit' />
            </p>
          </div>
        )}
      </div>
    </>
  );
};
export default NewLCInput;
